import React, { useEffect, useState } from "react";
import "../assets/styles/components/CardPaymentProcessingNotice.css";

export const CARD_PROCESSING_MESSAGES = [
  "Conectando com a operadora do cartão...",
  "Validando dados e segurança da transação...",
  "Processando pagamento junto à adquirente...",
  "Aguardando confirmação final da operadora...",
];

const CardPaymentProcessingNotice = ({
  active = false,
  intervalMs = 4000,
  className = "",
}) => {
  const [stepIndex, setStepIndex] = useState(0);

  useEffect(() => {
    if (!active) {
      setStepIndex(0);
      return undefined;
    }

    const timer = setInterval(() => {
      setStepIndex((prev) => (prev + 1) % CARD_PROCESSING_MESSAGES.length);
    }, intervalMs);

    return () => clearInterval(timer);
  }, [active, intervalMs]);

  if (!active) return null;

  return (
    <div
      className={`card-payment-processing-notice ${className}`.trim()}
      role="status"
      aria-live="polite"
      data-testid="card-payment-processing"
    >
      <progress
        aria-label="Processando pagamento com a operadora"
        className="loading-spinner"
      />
      <div className="card-payment-processing-notice__content">
        <p className="card-payment-processing-notice__step">
          {CARD_PROCESSING_MESSAGES[stepIndex]}
        </p>
        <p className="card-payment-processing-notice__hint">
          Estamos processando seu pagamento com a operadora. Por favor, aguarde e
          não feche ou atualize esta tela.
        </p>
      </div>
    </div>
  );
};

export default CardPaymentProcessingNotice;
